module.exports = __webpack_public_path__ + "static/media/Link-match-illustration.3eb14030.svg";